import { Trash } from "iconsax-react";
import styled, { css } from "styled-components";

export const Title = styled.h2`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutOnePage?.textColor};

  margin: 0 0 1rem;
`;

export const PaymentMethodsSection = styled.section``;

export const CreditCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
`;

export const LabelText = styled.span`
  display: flex;
  align-items: center;

  font-family: Inter;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5rem;
`;
export const LabelTextMobile = styled.span`
  display: flex;
  align-items: center;

  font-family: Inter;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5rem;

  @media (max-width: 900px) {
    font-family: Inter;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.125rem;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 0 0 auto;
  padding: 0 0 0 0.75rem;

  color: none;
  border: none;
  cursor: pointer;
  background: none;
`;

export const DeleteIcon = styled(Trash)`
  size: 1.25rem;
  color: ${({ theme }) => theme.checkoutOnePage?.red};
`;

export const WrapperIcon = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;

  margin: 0 0.75rem 0 0;
`;

interface IWrapperPaymentMethods {
  mobile: boolean;
  columns: number;
}

export const WrapperPaymentMethods = styled.div<IWrapperPaymentMethods>`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${(props) =>
    props.mobile &&
    css`
      display: grid;
      align-items: center;
      justify-content: center;

      grid-template-columns: repeat(${props.columns}, 1fr);

      @media (max-width: 315px) {
        gap: 0.45rem;
      }
    `}
`;
